var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOmSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    viewBox: "0 0 83.416722 33.041015",
    width: 83.416718,
    height: 33.041016,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs200"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style198"
  }, ".cls-1{fill:#212529;}.cls-2{fill:#202428;}.cls-3{fill:#39939e;}"))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path693",
    d: "M 35.462891,0 C 31.04294,0 26.939735,1.7574865 23.875,4.5820312 l 4.669922,4.671875 c 1.803406,-1.8549635 4.263381,-3.0273437 6.917969,-3.0273437 5.390653,0 9.943359,4.7414165 9.943359,10.2714845 0,5.576538 -4.552706,10.316406 -9.943359,10.316406 -3.611483,0 -6.857678,-2.168315 -8.585938,-5.292969 l -4.880859,4.88086 c 3.136583,4.00229 8.066981,6.638672 13.466797,6.638672 9.247758,0 16.960937,-7.574037 16.960937,-16.542969 C 52.423828,7.529114 44.710649,0 35.462891,0 Z",
    style: {
      fontWeight: "bold",
      fontSize: "46.4712px",
      fontFamily: "Metropolis",
      InkscapeFontSpecification: "'Metropolis Bold'",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.65967,
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 53.768089,32.483364 h 2.32356 V 5.390655 l 12.50076,23.514427 12.50075,-23.514427 v 27.092709 h 2.32356 V 0.55765 h -2.32356 L 68.592409,24.072077 56.091649,0.55765 h -2.32356 z",
    style: {
      fontWeight: "normal",
      fontSize: "46.4712px",
      fontFamily: "Metropolis",
      InkscapeFontSpecification: "Metropolis",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.65967,
      paintOrder: "markers stroke fill"
    },
    id: "path709"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontWeight: "bold",
      fontSize: "46.4712px",
      fontFamily: "Metropolis",
      InkscapeFontSpecification: "'Metropolis Bold'",
      display: "none",
      fill: "#ffffff",
      strokeWidth: 1.65967,
      paintOrder: "markers stroke fill"
    },
    x: 16.594681,
    y: -47.516636,
    id: "text445"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan443",
    x: 0,
    y: 0,
    style: {
      strokeWidth: 1.65967
    }
  }, "ONTOLOGY", /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Metropolis",
      InkscapeFontSpecification: "Metropolis",
      strokeWidth: 1.65967
    },
    id: "tspan497"
  }, "MANAGER"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 5.9265815,13.165307 1.2616812,17.813606 5.9099805,22.461905 10.55828,17.813606 5.9431826,13.165307 Z m 5.7439695,5.743969 -6.5242197,6.52422 6.5242197,6.52422 6.52422,-6.52422 z m 7.702896,-1.195277 -3.237208,3.270411 3.27041,3.270411 3.270411,-3.270411 -3.287012,-3.270411 z",
    id: "path206",
    style: {
      strokeWidth: 1.66011,
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 24.801997,9.9945026 14.990765,19.805734 5.1629324,9.9945026 14.974164,0.18327097 24.785396,9.9945026 Z M 2.3241496,21.399437 0,23.723586 l 2.3241496,2.32415 2.3241497,-2.32415 z",
    id: "path204",
    style: {
      strokeWidth: 1.66011
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOmSmall);
export default __webpack_public_path__ + "static/media/logoOMSmall.a3e1967b55a7d50dd63d56335af3bec5.svg";
export { ForwardRef as ReactComponent };